export const NAME = 'notifications';
export const LIMIT = 5;
